import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useSettings, waLink } from "@/context/AppContext";

export default function WhatsAppFloat() {
  const { settings } = useSettings();
  if (!settings) return null;
  return (
    <motion.a
      href={waLink(settings)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#1E4B33] text-parchment shadow-[0_10px_30px_rgba(7,27,19,0.45)] border border-gold/40"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.4, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
    >
      <MessageCircle className="h-6 w-6" />
      <span className="absolute inset-0 rounded-full border border-gold/50 animate-ping opacity-20" />
    </motion.a>
  );
}
